import { notifyError, notifySuccess } from "@/lib/notification";
import * as documentService from "@/services/document.service";
import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import { AxiosError } from "axios";

export const documentKey = {
  all: ["documents"] as const,
};

export const useDocumentsQuery = () =>
  useQuery({
    queryKey: documentKey.all,
    queryFn: documentService.fetchDocuments,
  });

export const useUploadDocumentMutation = () => {
  const queryClient = useQueryClient();
  return useMutation<
    documentService.DocumentType,
    AxiosError,
    { file: File; document_type: string }
  >({
    mutationFn: ({ file, document_type }) =>
      documentService.uploadDocument(file, document_type),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: documentKey.all });
      notifySuccess("Document uploaded successfully");
    },
    onError: (error: any) => {
      const apiError =
        error?.response?.data?.error?.message ||
        error?.response?.data?.message ||
        "Failed to upload document";
      notifyError(apiError);
    },
  });
};

export const useDeleteDocumentMutation = () => {
  const queryClient = useQueryClient();
  return useMutation<{ message: string }, AxiosError, string>({
    mutationFn: documentService.deleteDocument,
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: documentKey.all });
      notifySuccess("Document deleted successfully");
    },
    onError: (error: any) => {
      const apiError =
        error?.response?.data?.error?.message ||
        error?.response?.data?.message ||
        "Failed to delete document";
      notifyError(apiError);
    },
  });
};

// useVerifyDocumentMutation was removed alongside documentService.verifyDocument
// — document verification belongs to the college service, not this app.
